module.exports = __webpack_public_path__ + "static/img/serve1.512ee3e0.png";